module.exports = __webpack_public_path__ + "static/media/countries-50m.topo.json.514ed241.txt";